module.exports = __webpack_public_path__ + "modules/home/images/about_home_icon.png?ae4a2d89";


//////////////////
// WEBPACK FOOTER
// ./modules/home/images/about_home_icon.png
// module id = 53
// module chunks = 0